import clsx from 'clsx'
import { forwardRef } from 'react'

import { InputProps } from '~/types/component'

const Textarea = forwardRef<HTMLTextAreaElement, InputProps>((props, ref) => {
  const { disabled, errorMessage, ...rest } = props
  return (
    <div className="relative w-full">
      <textarea
        ref={ref}
        rows={2}
        className={clsx('w-full rounded-lg border-0 bg-jba-gray p-2 text-xs text-jba-blue focus:ring-0', [
          errorMessage
            ? 'ring-1 ring-inset ring-jba-red placeholder:text-jba-red focus:ring-inset focus:ring-jba-red'
            : 'placeholder:text-gray-400 focus:ring-0',
        ])}
        disabled={disabled}
        {...rest}
      ></textarea>
      {errorMessage && <span className="mt-4 text-xs text-jba-red">{errorMessage}</span>}
    </div>
  )
})

export default Textarea
